import { render, staticRenderFns } from "./TemperatureForm.vue?vue&type=template&id=6135249a&scoped=true"
import script from "./TemperatureForm.vue?vue&type=script&lang=js"
export * from "./TemperatureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135249a",
  null
  
)

export default component.exports